import { PropType, ref } from 'vue';
import { PresentationCardVue } from '@/fairplayer/primary/presentation-card';
import { CarouselVue } from '@/common/primary/carousel';
import { MemberCardVue } from '@/fairplayer/primary/members-page/members-list/member-card';
import { MemberUi } from '@/fairplayer/primary/members-page/Member.ui';

export default {
  name: 'MembersCarousel',

  components: { PresentationCardVue, CarouselVue, MemberCardVue },

  props: {
    members: {
      type: Array as PropType<MemberUi[]>,
      required: true,
    },
  },

  setup() {
    const currentIndex = ref(0);

    const setCurrentIndex = (index: number) => {
      currentIndex.value = index;
    };

    return {
      setCurrentIndex,
      currentIndex,
    };
  },
};
